import { IconWrapper } from "@insite/mobius/Icon";
import getColor from "@insite/mobius/utilities/getColor";
import Close from "@store/Components/Icons/Close";
import { TYPOGRAPHY } from "@store/theme/design";
import { buttonResetStyles } from "@store/theme/mixins";
import { css } from "styled-components";

export default {
    defaultProps: {
        color: "common.accent",
        typographyProps: {
            size: TYPOGRAPHY.size.smallest,
            weight: TYPOGRAPHY.weight.bold,
            color: "text",
        },
        iconProps: {
            src: Close,
            size: 12,
            color: "common.disabled",
        },
        css: css`
            display: inline-flex;
            margin: 0 10px 10px 0;
            padding: 0.6em 0.75em;
            min-height: 0;
            max-width: none;
            border-radius: 0;
            word-break: break-all;
            align-items: center;
            font-size: ${TYPOGRAPHY.size.smaller};
            line-height: ${TYPOGRAPHY.lineHeight.small};

            button {
                ${buttonResetStyles()}

                &:hover {
                    ${IconWrapper} {
                        color: ${getColor("primary")};
                    }
                }
            }
        `,
    },
};
